import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app.config';
import './app.css';
import './styles/button.css';
import './styles/tailwindcss-after.css';
bootstrapApplication(AppComponent, appConfig);
